import createItemFetcher from "../helpers/item";
import React from "react";
export function createVersions(config) {
    const { computeServerVersionUrl } = config;
    function computeItemId() {
        return `server`;
    }
    return createItemFetcher(computeServerVersionUrl, "Version", computeItemId);
}
export const VersionsContext = React.createContext({});
export * from "./front";
//# sourceMappingURL=index.js.map